import { render, staticRenderFns } from "./SidebarMinimizer.vue?vue&type=template&id=3c8af984&"
import script from "./SidebarMinimizer.vue?vue&type=script&lang=js&"
export * from "./SidebarMinimizer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports